
import { Vue, Component, Prop, Watch } from "vue-property-decorator";
import { schoolService } from "@/api/settings/school";
import { FormItem } from "element-ui";

@Component({})
export default class CurrentClassSelect extends Vue {
  @Prop({ default: false, type: Boolean }) isShowGardeNoAndClass: boolean;
  gradeNo: string = "";
  classNo = "";

  maxClass = 30;

  grades = [
    {
      value: 1,
      lable: "一",
    },
    {
      value: 2,
      lable: "二",
    },
    {
      value: 3,
      lable: "三",
    },
    {
      value: 4,
      lable: "四",
    },
    {
      value: 5,
      lable: "五",
    },
    {
      value: 6,
      lable: "六",
    },
    {
      value: 7,
      lable: "七",
    },
    {
      value: 8,
      lable: "八",
    },
    {
      value: 9,
      lable: "九",
    },
    {
      value: 10,
      lable: "高一",
    },
    {
      value: 11,
      lable: "高二",
    },
    {
      value: 12,
      lable: "高三",
    },
  ];
  classes = [];

  created() {}

  change() {
    this.$emit("change", {
      gradeNo: this.gradeNo,
      classNo: this.classNo,
    });
  }

  @Watch("isShowGardeNoAndClass")
  watchValue() {
    if (this.isShowGardeNoAndClass == false) {
      this.gradeNo = null;
      this.classNo = null;
    }
  }
}
